export const DATA_TESTID = {
  COMPARE_PLANS_ACCORDION: 'ComparePlansAccordion',
  COMPARE_PLANS_TABLE: 'ComparePlansTable',
}
